/* eslint-disable */
import { trim } from '@/support/String';
import Token from '@/support/Token';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { Config } from '@/support/Config';
const Qs = require('qs');
import { Application } from '@/support/Application';

let API = '';

export const objectToFormdata = (payload: any, form: any = null, namespace: any = null): FormData => {
  const fd: FormData = form || new FormData();
  let formKey: string | null = null;

  Object.keys(payload).forEach((key: string) => {
    if (namespace) {
      formKey = `${namespace}[${key}]`;
    } else {
      formKey = key;
    }
    if (typeof payload[key] === 'object' && !(payload[key] instanceof File)) {
      objectToFormdata(payload[key], fd, key);
    } else {
      fd.append(formKey, payload[key]);
    }
  });
  return fd;
};


export const identifyHostname = (): string => {
  const hostName = trim('.', Application.config('APP_API') as string);
  const applicationName = identifyApplication();
  const hostProtocol = isHttps() ? 'https' : 'http';
  return `${hostProtocol}://${hostName}`;
};


export const isHttps = (): boolean => {
  return Application.config('APP_API_HTTPS') && Application.config('APP_API_HTTPS') === 'false' ? false : true;
};

export const identifyAppHostname = (): string => {
  const hostName = trim('.', Application.config('APP_HOSTNAME') as string);
  return `${hostName}`;
};


export const identifyApplication = (): string => {
  const host = window.location.host;
  const application = host.split('.')[0];

  if (application.includes('localhost:') || host.includes(':8080')) {
    if (Application.config('APP_TENANT')) {
      return Application.config('APP_TENANT') as string;
    }
    return '';
  }

  return application;
};

export default (method: string, headers: {[key: string]: string}, url: string, payload: object) => {
  API = Config.get('APP_HOST_API') as string;

  if (Token.get('access')) {
    headers.Authorization = `Bearer ${Token.get('access')}`;
  }

  const urlData = new URL(url);
  const baseUrl = trim('/', `${urlData.protocol}//${urlData.hostname}`);
  const pathUrl = `${urlData.pathname}${urlData.search}`;

  const client = axios.create({
    baseURL: baseUrl,
    headers,
    /* eslint-disable-next-line */
    paramsSerializer: (params: any) => Qs.stringify(params, { arrayFormat: 'brackets' }),
  });

  let hasFile = false;
  const keys = Object.keys(payload);
  let attributes = {};
  keys.forEach((property) => {
    if (
      (payload as any)[property] !== undefined
      && (payload as any)[property] !== null
      && (payload as any)[property].name !== undefined
      && (payload as any)[property].lastModified !== undefined
      && (payload as any)[property].size !== undefined
    ) {
      hasFile = true;
    }
  });

  if (hasFile) {
    attributes = objectToFormdata(payload);
  }

  if (method.toLowerCase() === 'get' || method.toLowerCase() === 'delete') {
    attributes = {
      params: payload,
    };
  } else {
    attributes = payload;
  }

  return (client as any)
    /* eslint-disable-next-line */
    [method.toLowerCase()](pathUrl, attributes)
    .then((response: AxiosResponse) => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
